module.exports = __webpack_public_path__ + "img/zdyx1.87f45ef2.png";